import { QuestionPickerObjective } from 'pages/custom_tests_v1/components/question_picker/components/QuestionPickerObjective';
import type { QuestionTheme } from 'pages/custom_tests_v1/components/question_picker/QuestionPicker';
import { useQuestionPicker } from 'pages/custom_tests_v1/components/question_picker/context';
import { Accordion, Badge, Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

type QuestionPickerThemeProps = {
    productId: number;
    theme: QuestionTheme;
};

export const QuestionPickerTheme = (props: QuestionPickerThemeProps) => {

    const { productId, theme } = props;

    const { deselectAllInTheme, getFilteredObjectives, getThemeSelectedCount, getThemeTotalCount, selectAllInTheme } = useQuestionPicker();

    const eventKey = `${productId}-${theme.ThemeId}`;
    const filteredObjectives = getFilteredObjectives(theme.Objectives ?? []);
    const selectedCount = getThemeSelectedCount(theme);
    const totalCount = getThemeTotalCount(theme);

    return (
        <>
            {!!filteredObjectives?.length && (
                <Accordion.Item eventKey={eventKey}>

                    <Accordion.Header>
                        <span className="font-weight-bold flex-grow-1">
                            {theme.Name}
                        </span>
                        <div
                            className="d-flex align-items-center gap-1 px-2"
                            onClick={e => e.stopPropagation()}
                        >
                            <Badge bg={'secondary'}>
                                {selectedCount}
                                /
                                {totalCount}
                            </Badge>
                            <Button
                                onClick={e => {

                                    e.stopPropagation();
                                    selectAllInTheme(theme);

                                }}
                                size={'sm'}
                                type="button"
                                variant={'outline-primary'}
                            >
                                <FormattedMessage defaultMessage="Select All" id="select_all.dd487b25" />
                            </Button>
                            <Button
                                onClick={e => {

                                    e.stopPropagation();
                                    deselectAllInTheme(theme);

                                }}
                                size={'sm'}
                                type="button"
                                variant={'outline-secondary'}
                            >
                                <FormattedMessage defaultMessage="Deselect All" id="deselect_all.da9ca1dd" />
                            </Button>
                        </div>
                    </Accordion.Header>

                    <Accordion.Body className="py-2">
                        {filteredObjectives.length > 0
                            ? filteredObjectives.map(objective => (
                                <QuestionPickerObjective
                                    key={objective.ObjectiveId}
                                    objective={objective}
                                />
                            ))
                            : (
                                <p className="text-muted small mb-0">
                                    <FormattedMessage defaultMessage="No questions match the current filters." id="no_questions_match_the_current_filters.f41de4ea" />
                                </p>
                            )
                        }
                    </Accordion.Body>

                </Accordion.Item>
            )}
        </>
    );

};
